import { guid } from './index'
export function flat(list, prop) {
  return [].concat(...list.map(item => [].concat(item[prop], ...flat(item.children || [], prop)))).filter(item => item)
}

function formatMenuItem(item) {
  const { menuId, menuName, funcAddress, children } = item
  console.log(flat(children || [], 'funcAddress')[0], funcAddress, menuName)
  const childrenList = (children || []).length === 0 ? null : formatMenuList(children)
  return {
    menuId,
    menuName,
    funcAddress: funcAddress || flat(children || [], 'funcAddress')[0],
    guId: guid(),
    children: childrenList
  }
}
export function formatMenuList(list) {
  return list.map(item => formatMenuItem(item))
}
